import { useState } from "react";
import { Typography } from "@mui/material";
import { ThemeWrapper } from "@verity/components";
import { CoreSwitch } from "@verity/components/core";
import apiClient from "../../../../helpers/api-client";
import i18n from "../../../../i18n";
import { CustomSettingData } from "../../settings-page";

export const ManagedGuestSessionRequireIncognitoInput = ({
	loadData,
	setting,
	onSettingChange,
	disabled,
}: {
	loadData: { managedGuestSessionRequireIncognito: boolean };
	setting: CustomSettingData<boolean>;
	onSettingChange: (value?: boolean) => void;
	disabled?: boolean;
}) => {
	const [managedGuestSessionRequireIncognito, setManagedGuestSessionRequireIncognito] = useState(
		setting.value ?? loadData.managedGuestSessionRequireIncognito,
	);

	const updateSettings = (requireIncognito: boolean) => {
		setManagedGuestSessionRequireIncognito(requireIncognito);
		onSettingChange(requireIncognito);
	};

	return (
		<ThemeWrapper>
			<div style={{ maxWidth: "100%", overflowX: "auto" }}>
				<div style={{ minWidth: "420px" }}>
					<div style={{ display: "flex", paddingRight: "5px" }}>
						<div style={{ marginRight: "15px" }}>
							<Typography fontSize={14} lineHeight={1.6}>
								{i18n.t("portal.components.settings.managedGuestSessionRequireIncognito.description")}
							</Typography>
						</div>
						<CoreSwitch
							checked={!managedGuestSessionRequireIncognito}
							onChange={(e) => updateSettings(!e.target.checked)}
							disabled={disabled}
							labelTextType="left"
						/>
					</div>
				</div>
			</div>
		</ThemeWrapper>
	);
};

export async function saveManagedGuestSessionRequireIncognito(instituteUuid?: string, requireIncognito?: boolean) {
	try {
		if (instituteUuid) {
			if (typeof requireIncognito === "boolean") {
				await apiClient.institute.updateSettings(instituteUuid, {
					managedGuestSessionRequireIncognito: requireIncognito,
				});
			}
		} else {
			throw new Error("no instituteId");
		}
		return { ok: true };
	} catch (error) {
		console.error(error);
		return { ok: false, reason: "Failed to save managed guest session incognito setting." };
	}
}
